import Head from 'next/head';
import React from 'react';

import ProductLayout from '../../../components/ProductComp/layout';
import CoursesSection from '../../../components/ProjectHomePage/CoursesSection';
import { pageTitle } from '../../../components/shared/basic/customHead';

const ProductCoursesPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>{pageTitle('Products - Courses')}</title>
      </Head>
      <ProductLayout>
        <div id='courses'>
          <CoursesSection isPagination={true} />
        </div>
      </ProductLayout>
    </>
  );
};

export default ProductCoursesPage;
